import React from 'react';
import { formatFileSize } from '../../util';

class UploadDropzone extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			dragEnterCount: 0,
			isHover: false
		};

		this.handleDragEnter = this.handleDragEnter.bind(this);
		this.handleDragLeave = this.handleDragLeave.bind(this);
    	this.handleDrop = this.handleDrop.bind(this);
	}


    handleDragOver(e) {
		e.preventDefault();
	}

	handleDragEnter(e) {
		const dragEnterCount = this.state.dragEnterCount + 1;
		this.setState({ dragEnterCount })
		if(dragEnterCount === 1) this.setState({isHover: true})
	}

	handleDragLeave(e) {
		const dragEnterCount = this.state.dragEnterCount - 1;
		this.setState({ dragEnterCount })
		if(dragEnterCount === 0) this.setState({isHover: false});
	}

	handleDrop(e) {
		e.preventDefault();
		let files = [];
		if (e.dataTransfer.items) {
			for (var i = 0; i < 1; i++) {
//			for (var i = 0; i < e.dataTransfer.items.length; i++) {
				if (e.dataTransfer.items[i].kind === 'file') {
					const file = e.dataTransfer.items[i].getAsFile();

					if(file.size > 1024 * 1024 * 6) {
						alert(`${file.name} ist größer als 6MB (${formatFileSize(file.size)}). Um größere Dateien mit anderen zu teilen, nutze bitte SeaFile.`);
						continue;
					}

					/*file.key = getFileKey(file);
					const exists = currentFiles.find(f => f.key === file.key);
					if(!exists) */
					files.push(file);
				}
			}
		} /*else { //Safari, IE
	    // Use DataTransfer interface to access the file(s)
			for (var i = 0; i < e.dataTransfer.files.length; i++) {
				console.log('... file[' + i + '].name = ' + e.dataTransfer.files[i].name);
			}
		}*/
	}
	
	render() {

		let className = this.state.isHover ? 'upload upload-hover' : 'upload';

		return (
			<div className={className} 
					onDragEnter={this.handleDragEnter} 
					onDragLeave={this.handleDragLeave} 
					onDragOver={this.handleDragOver} 
					onDrop={this.handleDrop}>
						<span>drop files here :3</span>
			</div>
		);
	}
}

export default UploadDropzone


// WEBPACK FOOTER //
// ./src/components/upload/UploadDropzone.js